import * as S from "./styles.ts";
import {
  Error,
  Hint,
  InputLabel,
  InputWrapper,
} from "@template/components/Input/styles.ts";
import RadioBlob from "@template/components/RadioBlob";

type TSelected = string | number | null;

type TOption = {
  label?: string;
  key: string | number;
};

export interface IRadioProps {
  label?: string;
  hint?: string;
  disabled?: boolean;
  error?: string | boolean;
  selected?: TSelected | TSelected[];
  onChange?: (val: TSelected | TSelected[], e?: any) => void;
  options: TOption[];
}

const Radio = ({
  label,
  hint,
  disabled,
  error,
  selected = [],
  onChange = () => null,
  options,
}: IRadioProps) => {
  const selectedIsArray = Array.isArray(selected);

  const handleToggle = (key: string | number, e: any) => {
    if (selectedIsArray) {
      if (selected.includes(key)) {
        onChange(
          selected.filter((item: any) => item !== key),
          e
        );
      } else {
        onChange([...selected, key], e);
      }
    } else {
      onChange(selected === key ? null : key, e);
    }
  };
  return (
    <S.RadioWrapper>
      <InputWrapper>
        {label && <InputLabel>{label}</InputLabel>}
        <S.RadioContainer>
          {options.map((opt) => (
            <S.RadioOption
              onClick={(e) => handleToggle(opt.key, e)}
              key={opt.key}
            >
              <RadioBlob
                selected={
                  selectedIsArray
                    ? selected.includes(opt.key)
                    : selected === opt.key
                }
                disabled={disabled}
              />
              {opt.label && (
                <S.RadioOptionLabel>{opt.label}</S.RadioOptionLabel>
              )}
            </S.RadioOption>
          ))}
        </S.RadioContainer>
        {hint && typeof error !== "string" && <Hint>{hint}</Hint>}
        {typeof error === "string" && <Error>{error}</Error>}
      </InputWrapper>
    </S.RadioWrapper>
  );
};
export default Radio;
